import React from 'react';

import { TextField } from 'Containers/App/types';
import { Icon, Paragraph, Spinner } from 'DesignLibrary/atoms';
import Text from 'Shared/Text';

export type Suggestion = {
  key: string;
  title: string;
  description: string;
};

export interface SuggestionsListProps {
  suggestionKey: string;
  noResultsField: TextField;
  showLoading: boolean;
  userInput: string;
  suggestions: Suggestion[];
  activeSuggestion: number;
  onSuggestionClick: (e, idx) => void;
}

export const SuggestionsList = ({
  suggestionKey,
  noResultsField,
  showLoading,
  userInput,
  suggestions,
  activeSuggestion,
  onSuggestionClick,
}: SuggestionsListProps): JSX.Element => (
  <ul className="suggestions" role="listbox" id={`${suggestionKey}-suggestions`}>
    {!showLoading && userInput.length > 2 ? (
      suggestions.length === 0 ? (
        <div className="no-results">
          <Icon type="Warning" color="--primary-yellow" />
          <Text field={noResultsField} />
        </div>
      ) : (
        suggestions.map((suggestion, idx) => {
          let className;

          if (idx === activeSuggestion) {
            className = 'suggestion-active';
          }

          return (
            <li
              className={className}
              key={suggestion.key}
              role="option"
              aria-selected={idx === activeSuggestion}
            >
              <button
                id={`typeahead-suggestion-${idx}`}
                type="button"
                className="suggestion-item"
                onMouseDown={(e) => onSuggestionClick(e, idx)}
              >
                <Paragraph weight="bold" color="--text-black" as="h4">
                  {suggestion.title}
                </Paragraph>
                <Paragraph size="small">{suggestion.description}</Paragraph>
              </button>
            </li>
          );
        })
      )
    ) : (
      <div className="loading">
        {showLoading ? (
          <Spinner color="--border-gray" />
        ) : (
          <Paragraph size="small">Please add at least 3 letters.</Paragraph>
        )}
      </div>
    )}
  </ul>
);
